function initializeRecording() {
    if (window.recordingInitialized) {
        return;
    }
    let recorder;
    let screenStream;
    let webcamStream;
    let webcamPreview;

    function invokeGetDisplayMedia(success, error) {
        const displaymediastreamconstraints = {
            video: {
                displaySurface: 'browser',
                cursor: 'always'
            },
            audio: false,
            selfBrowserSurface: 'include',
            preferCurrentTab: true
        };

        const getDisplayMedia = navigator.mediaDevices.getDisplayMedia || navigator.getDisplayMedia;

        getDisplayMedia.call(navigator.mediaDevices || navigator, displaymediastreamconstraints)
            .then(success)
            .catch(error);
    }

    function captureScreen(callback) {
        invokeGetDisplayMedia(function (screen) {
            screenStream = screen;
            addStreamStopListener(screen, function () {
                if (window.stopCallback) {
                    window.stopCallback();
                }
            });
            callback(screen);
        }, function (error) {
            console.error('Error capturing screen:', error);
            alert('Unable to capture your screen. Please check console logs.\n' + error);
        });
    }

    function captureCamera(cb) {
        navigator.mediaDevices.getUserMedia({ audio: true, video: { facingMode: 'user' } })
            .then(stream => {
                webcamStream = stream;
                showWebcamPreview(stream);
                cb(stream);
            })
            .catch(error => {
                console.error("Error accessing webcam:", error);
            });
    }

    function showWebcamPreview(stream) {
        if (!webcamPreview) {
            webcamPreview = document.createElement('video');
            webcamPreview.autoplay = true;
            webcamPreview.muted = true;
            webcamPreview.style.position = 'fixed';
            webcamPreview.style.bottom = '50px';
            webcamPreview.style.left = '10px';
            webcamPreview.style.width = '305px';
            webcamPreview.style.height = '230px';
            webcamPreview.style.border = '2px solid #fff';
            webcamPreview.style.zIndex = '1000';
            document.body.appendChild(webcamPreview);
        }
        webcamPreview.srcObject = stream;
    }

    function startCountdown(seconds, callback) {
        let countdownDiv = document.createElement("div");
        countdownDiv.id = "countdownOverlay";
        Object.assign(countdownDiv.style, {
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            fontSize: "5rem",
            color: "white",
            background: "rgba(0, 0, 0, 0.7)",
            padding: "20px",
            borderRadius: "10px",
            textAlign: "center",
            zIndex: "10000"
        });
        document.body.appendChild(countdownDiv);
    
        let countdown = seconds;
        countdownDiv.innerText = countdown;
    
        let countdownInterval = setInterval(() => {
            countdown -= 1;
            if (countdown === 0) {
                clearInterval(countdownInterval);
                document.body.removeChild(countdownDiv);
                callback(); // Start the recording after countdown
            } else {
                countdownDiv.innerText = countdown;
            }
        }, 1000);
    }

    function startRecording() {
        if (recorder && recorder.getState() === 'recording') {
            return;
        }

        captureScreen(function (screen) {
            captureCamera(function (stream) {
                let combinedStream = new MediaStream();

                // Add screen video tracks
                screen.getTracks().forEach(track => combinedStream.addTrack(track));

                // Add camera audio track
                stream.getTracks().forEach(track => {
                    if (track.kind === 'audio') { 
                        combinedStream.addTrack(track);
                    }
                });

                document.documentElement.requestFullscreen().catch(err => {
                    console.warn("Fullscreen request failed:", err);
                });

                recorder = RecordRTC([combinedStream], {
                    type: 'video',
                    mimeType: 'video/mp4',
                    previewStream: function (s) {
                        let videoElement = document.querySelector('#recording-preview') || document.createElement('video');
                        videoElement.id = 'recording-preview';
                        videoElement.muted = true;
                        videoElement.srcObject = s;
                        videoElement.style.display = 'block';
                        document.body.appendChild(videoElement);
                    }
                });
                combinedStream.width = window.screen.width;
                combinedStream.height = window.screen.height;
                startCountdown(5, () => {
                    recorder.startRecording();
                    $('#video-buttons').addClass('sticky-bottom');
                });
                
                if (!document.getElementById("recordingBorder")) {
                    let border = document.createElement("div");
                    border.id = "recordingBorder";
                    Object.assign(border.style, {
                        position: "fixed",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        boxShadow: "inset 0 0 0 2px rgba(128, 128, 128, 0.5)",
                        pointerEvents: "none",
                        zIndex: "9999"
                    });

                    document.body.appendChild(border);
                }
                updateUI(true);
            });
        });
    }

    function stopRecording() {
        let border = document.getElementById("recordingBorder");
        if (border) {
            border.remove(); // Remove the red border
        }
        $('#video-buttons').removeClass('sticky-bottom');
        if (recorder) {
            recorder.stopRecording(function () {
                let blob = recorder.getBlob();
                blob.type = "video/mp4";

                if (webcamPreview) {
                    webcamPreview.remove();
                    webcamPreview = null;
                }

                if (screenStream) {
                    screenStream.getTracks().forEach(track => track.stop());
                    screenStream = null;
                }

                if (webcamStream) {
                    webcamStream.getTracks().forEach(track => track.stop());
                    webcamStream = null;
                }
                uploadToFilestack(blob);
                updateUI(false);
            });
        }
    }

    function uploadToFilestack(blob) {
        const videoUrl = $("#response_video_url");
        const video = $("#video");
        const client = filestack.init(process.env['FILESTACK_API_KEY']);

        client.upload(blob)
            .then((uploadRes) => {
                const videoTag = `<video controls="controls" src="${uploadRes.url}" width="400"></video>`;
                videoUrl.val(uploadRes.url);
                video.html(videoTag);
                $("#file-uploading").addClass("hidden");
                $("#btn-start-recording span").text("Re-record Video");
                triggerAutosave();
            })
            .catch((error) => {
                console.error('Error uploading file to Filestack:', error);
            });
    }

    function updateUI(recordingActive) {
        let hasVideoField = !!document.querySelector("#response_video_url");
        let stopBtn = document.querySelector("#btn-stop-recording");
        let downloadBtn = document.querySelector("#btn-download");
        let deleteBtn = document.querySelector("#btn-delete");

        if (stopBtn) stopBtn.style.display = recordingActive && hasVideoField ? "block" : "none";
        if (downloadBtn) downloadBtn.style.display = hasVideoField ? "block" : "none";
        if (deleteBtn) deleteBtn.style.display = hasVideoField ? "block" : "none";
    }

    function addStreamStopListener(stream, callback) {
        stream.addEventListener('ended', callback, false);
        stream.addEventListener('inactive', callback, false);
        stream.getTracks().forEach(track => {
            track.addEventListener('ended', callback, false);
            track.addEventListener('inactive', callback, false);
        });
    }
    
    document.getElementById("btn-start-recording")?.addEventListener('click', function() {
        startRecording();
        $("#btn-stop-recording").removeClass("hidden");
        $("#btn-start-recording").addClass("hidden");
    } );
    document.getElementById("btn-stop-recording")?.addEventListener('click', function() {
        document.exitFullscreen();
        $("#file-uploading").removeClass("hidden");
        $("#btn-stop-recording").addClass("hidden");
        $("#btn-start-recording").removeClass("hidden");
        stopRecording();
    } );
    updateUI(false);

    window.recordingInitialized = true;
}

document.addEventListener('turbolinks:load', function () {
    window.recordingInitialized = false;
    initializeRecording();
});
